import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/Settings';

import quoteIconSrc from '@Calix-Commerce/design-system/assets/img/quote-icon.png';
import rmaIconSrc from '@Calix-Commerce/design-system/assets/img/rma-icon.png';
import orderIconSrc from '@Calix-Commerce/design-system/assets/img/order-icon.png';

import {
  authenticationState,
  baseAccountState,
  currentAccountState,
  currentQuoteState,
} from 'state/atoms';
import { CALIX_EMPLOYEE, VAR } from 'connectors/userTypes';
import { QUOTE, RMA_MANAGER_USER, RMA_MANAGER_MANAGER } from 'connectors/permissions';
import {
  CART_URL,
  CART_NEW_URL,
  QUOTE_LIST_URL,
  RMA_MANAGER_URL,
  RMA_NEW_CASE_DETAILS_URL,
  RMA_NEW_CASE_SEARCH_URL,
} from 'utils/constants';
import { useFormatPrice } from 'utils/hooks';
import { getAccountsUrlWithReturn } from 'utils/helpers/url';

import { Menu, MenuDropdown, MenuTotal, Account, QuoteName } from './styledComponents';
import { Option } from './Option';
import { Feedback } from './Feedback';
import { getQuoteFromStorage } from 'connectors/storage';

const MainMenu = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const history = useHistory();

  const { quoteName, quoteTotal } = useRecoilValue(currentQuoteState);
  const { account, userType, eCommerceAccess } = useRecoilValue(authenticationState);
  const baseAccount = useRecoilValue(baseAccountState);
  const currentAccount = useRecoilValue(currentAccountState);

  const { currencyCode } = getQuoteFromStorage({
    defaultCurrencyCode:
      baseAccount?.defaultCurrencyCode || currentAccount.defaultCurrencyCode || 'USD',
  });

  const formatPrice = useFormatPrice(currencyCode);
  const showSettings = [CALIX_EMPLOYEE, VAR].some((type) => userType.includes(type));

  const canAccessQuotes = eCommerceAccess.includes(QUOTE);
  const canAccessRma = [RMA_MANAGER_USER, RMA_MANAGER_MANAGER].some((access) =>
    eCommerceAccess.includes(access)
  );

  return (
    <Menu
      isOpen={isDropdownOpen}
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      onClickOutside={() => setIsDropdownOpen(false)}
    >
      <div>Current Quote</div>
      <QuoteName>
        <b>{quoteName || 'No quote name'}</b>
      </QuoteName>
      <MenuTotal>{formatPrice(quoteTotal)}</MenuTotal>
      <MenuDropdown propagateClick isOpen={isDropdownOpen} position="left">
        {showSettings && (
          <SettingsIcon
            onClick={() =>
              window.location.assign(
                getAccountsUrlWithReturn(`${window.location.origin}/order-manager/orders`)
              )
            }
          />
        )}
        <Account showSettings={showSettings}>{account}</Account>
        {canAccessQuotes && (
          <Option
            iconSrc={quoteIconSrc}
            text="Quotes"
            onClick={() => window.location.assign(QUOTE_LIST_URL)}
            onEyeClick={() => window.location.assign(CART_URL)}
            onPlusClick={() => window.location.assign(CART_NEW_URL)}
          />
        )}
        {canAccessRma && (
          <Option
            iconSrc={rmaIconSrc}
            text="RMAs"
            onClick={() => window.location.assign(RMA_MANAGER_URL)}
            onEyeClick={() => window.location.assign(RMA_NEW_CASE_DETAILS_URL)}
            onPlusClick={() => window.location.assign(RMA_NEW_CASE_SEARCH_URL)}
          />
        )}
        <Option selected iconSrc={orderIconSrc} text="Orders" onClick={() => history.push('/')} />
        <Feedback />
      </MenuDropdown>
    </Menu>
  );
};

export { MainMenu };
